module.exports = __webpack_public_path__ + "img/File.ddf84429.svg";